import { Vue } from "../vue-ext";
import VueRouter from "vue-router";
import { OwnInfo } from "../models"

import StartView from "../views/StartView.vue";
import ChooseHousingCompanyView from "../views/ChooseHousingCompanyView.vue";
import HousingCompanyNotAvailableView from "../views/HousingCompanyNotAvailableView.vue";
import InputEmailView from "../views/InputEmailView.vue";
import InputPinView from "../views/InputPinView.vue";
import InputRegisterFormView from "../views/InputRegisterFormView.vue";

import WelcomeView from "../views/WelcomeView.vue";
import HousingCompanyInfoView from "../views/HousingCompanyInfoView.vue";
import ContentView from "../views/ContentView.vue";
import OwnInfoView from "../views/OwnInfoView.vue";
import OwnInfoEditView from "../views/OwnInfoEditView.vue";
import MessagesView from "../views/MessagesView.vue";
import MessageView from "../views/MessageView.vue";
import MaterialBankView from "../views/MaterialBankView.vue";
import MaterialView from "../views/MaterialView.vue";
import SaunaShiftsView from "../views/SaunaShiftsView.vue";
import ParkingView from "../views/ParkingView.vue";
import NotesView from "../views/NotesView.vue";
import EmergencyPlanView from "../views/EmergencyPlanView.vue";
import ArrivalNoticeView from "../views/ArrivalNoticeView.vue";
import DefectNoticeView from "../views/DefectNoticeView.vue";
import LeavingNoticeView from "../views/LeavingNoticeView.vue";
import RequestsView from "../views/RequestsView.vue";
import RequestView from "../views/RequestView.vue";

Vue.use(VueRouter);

export default class Router {
    public static getRouter() {
        return new VueRouter({
            mode: "abstract",
            // linkActiveClass: "active",
            routes: [
                { name: "StartView", path: "/", component: StartView },
                { name: "ChooseHousingCompanyView", path: "/choose-housing-company", component: ChooseHousingCompanyView },
                { name: "HousingCompanyNotAvailableView", path: "/housing-company-not-available", component: HousingCompanyNotAvailableView },
                { name: "InputEmailView", path: "/input-email", component: InputEmailView },
                { name: "InputPinView", path: "/input-pin", component: InputPinView },
                { name: "InputRegisterFormView", path: "/input-register", component: InputRegisterFormView },

                // After logged in
                { name: "ContentView", path: "/content", component: ContentView, children: [
                    { name: "WelcomeView", path: "welcome", component: WelcomeView },
                    { name: "HousingCompanyInfoView", path: "housing-company-info", component: HousingCompanyInfoView },
                    { name: "OwnInfoView", path: "own-info", component: OwnInfoView },
                    { name: "OwnInfoEditView", path: "own-info/edit", component: OwnInfoEditView },
                    { name: "MessagesView", path: "messages", component: MessagesView },
                    { name: "MessageView", path: "messages/:id", component: MessageView },
                    { name: "MaterialBankView", path: "materials", component: MaterialBankView },
                    { name: "MaterialView", path: "materials/:id", component: MaterialView },
                    { name: "SaunaShiftsView", path: "sauna", component: SaunaShiftsView },
                    { name: "ParkingView", path: "parking", component: ParkingView },
                    { name: "NotesView", path: "notes", component: NotesView },
                    { name: "EmergencyPlanView", path: "emergency-plan", component: EmergencyPlanView },
                    { name: "ArrivalNoticeView", path: "arrival-notice/:housingCompanyId?", component: ArrivalNoticeView },
                    { name: "DefectNoticeView", path: "defect-notice/:housingCompanyId/:apartmentId?", component: DefectNoticeView },
                    { name: "LeavingNoticeView", path: "leaving-notice/:housingCompanyId/:accountId/:apartmentId", component: LeavingNoticeView },
                    { name: "RequestsView", path: "requests", component: RequestsView },
                    { name: "RequestView", path: "requests/:id", component: RequestView },
                ] },

               // { path: "*", redirect: "/" },
            ],
        });
    }
}
